<template>
  <div>
    <div class="row" style="height: 60px"></div>
    <div class="row titleRow">
      <div class="col">
        <h2>{{$t('targetFitness.subtitle')+$store.state.form.resultJson.userInfos.firstname+" "+$store.state.form.resultJson.userInfos.lastname}}</h2>
        <h1>{{$t('targetFitness.title')}}</h1>
      </div>
    </div>
    <div v-for="i in Math.ceil((targetFitnessList.length)/nbColumn)" :key="i" class="row listOfButtons">
      <div v-for="(item, index) in targetFitnessList.slice((i-1)*nbColumn, (i-1)*nbColumn+nbColumn)" :key="index" class="col-3">
        <a @click="addElementToList((i-1)*nbColumn+index)"><img :src="targetFitnessImgList[(i-1)*nbColumn+index]" alt="ImgFitness" class="imgBig clickableItem" /><br/>
        <button :class="'btn btn-secondary targetButton ' + ((alreadyListed((i-1)*nbColumn+index) !== false) ? 'bg-color' : '')">{{item}}</button></a>
      </div>
    </div>
    <h2 class="titleSlider">{{$t('targetFitness.titleSlider')}}</h2>
    <vue-slider v-if="isActivated === true" ref="sliderForm" class="sliderComponent" v-bind="options" v-model="actualForm"
                v-on:drag-start="$store.commit('form/SLIDER_DRAG_EVENT', true)" v-on:drag-end="$store.commit('form/SLIDER_DRAG_EVENT', false)">
      <template slot="tooltip" slot-scope="{ value }">
        <div class="diy-tooltip" style="color: #FFFFFF; position: relative; bottom:43px">
          {{ value }}
        </div>
      </template>
      <template slot="label" slot-scope="{ label, active }">
        <span :class="['custom-label', { active }]" v-if="label % 2 === 0 && label !== 0" style="position: relative; top:40px; color : #909090">
          {{ label }}
        </span>
      </template>
    </vue-slider>
    <div class="row">
      <div class="col overFooter">
        <button type="submit" :class="'btn btn-primary alignRight ' + ((returnTargetList.length > 0) ? 'bg-color' : '')" @click="saveData()">{{$t('general.next')}}</button>
      </div>
    </div>
  </div>

</template>

<script>
import vueSlider from 'vue-slider-component';
export default {
  name: 'target-fitness',
  components: {
    vueSlider
  },
  data () {
    return {
      nbColumn: 4,
      isActivated: true,
      backgroundColorRight: '96C13C',
      backgroundColorLeft: 'fb5048',
      backgroundColor: this.backgroundColorLeft,
      backgroundColorRed: '96',
      backgroundColorGreen: 'C1',
      backgroundColorBlue: '3C',
      actualForm: 0,
      returnTargetList: [],
      targetFitnessList: [
        this.$i18n.t('targetFitness.strenght'),
        this.$i18n.t('targetFitness.stamina'),
        this.$i18n.t('targetFitness.flexibility'),
        this.$i18n.t('targetFitness.coordination')],
      targetFitnessVarList: [
        'strenght',
        'stamina',
        'flexibility',
        'coordination'],
      targetFitnessImgList: [
        'https://sales.deciplus.pro/static/img/TargetFitness/strenght.png',
        'https://sales.deciplus.pro/static/img/TargetFitness/stamina.png',
        'https://sales.deciplus.pro/static/img/TargetFitness/flexibility.png',
        'https://sales.deciplus.pro/static/img/TargetFitness/coordination.png'],
      options: {
        dotSize: 50,
        min: 0,
        max: 10,
        piecewiseLabel: true,
        tooltipDir: 'bottom',
        sliderStyle: [
          {
            'backgroundColor': '#fb5048'
          },
          {
            'backgroundColor': '#fb5048'
          }
        ],
        processStyle: {
          // 'backgroundColor': 'unset'
          // 'backgroundImage': '-webkit-linear-gradient(left, #96C13C, #fb5048)' // Gradient de couleur du vert vers le rouge
          'backgroundImage': '' // Gradient de couleur du rouge vers le vert
        }
      }
    };
  },
  updated: function () {
    // Vérifie si les champs obligatoires ont bien été remplis
    this.$store.dispatch('form/FORM_AUTHORIZENEXTSTEP', {layout: 'TargetFitness', isAuthorized: this.returnTargetList.length !== 0, data: this.dataTosave});
    this.backgroundColorRed = (Math.round(parseInt(this.backgroundColorRight[0] + this.backgroundColorRight[1], 16) - ((parseInt(this.backgroundColorRight[0] + this.backgroundColorRight[1], 16) - parseInt(this.backgroundColorLeft[0] + this.backgroundColorLeft[1], 16)) * (1 - (this.actualForm / this.options.max)))).toString(16));
    this.backgroundColorGreen = (Math.round(parseInt(this.backgroundColorRight[2] + this.backgroundColorRight[3], 16) - ((parseInt(this.backgroundColorRight[2] + this.backgroundColorRight[3], 16) - parseInt(this.backgroundColorLeft[2] + this.backgroundColorLeft[3], 16)) * (1 - (this.actualForm / this.options.max)))).toString(16));
    this.backgroundColorBlue = (Math.round(parseInt(this.backgroundColorRight[4] + this.backgroundColorRight[5], 16) - ((parseInt(this.backgroundColorRight[4] + this.backgroundColorRight[5], 16) - parseInt(this.backgroundColorLeft[4] + this.backgroundColorLeft[5], 16)) * (1 - (this.actualForm / this.options.max)))).toString(16));
    this.backgroundColor = this.backgroundColorRed + this.backgroundColorGreen + this.backgroundColorBlue;
    this.options.processStyle.backgroundImage = '-webkit-linear-gradient(left, #' + this.backgroundColorLeft + ', #' + this.backgroundColor + ')';
    this.options.sliderStyle[0].backgroundColor = '#' + this.backgroundColor;
    this.options.sliderStyle[1].backgroundColor = '#' + this.backgroundColor;
  },
  deactivated: function () {
    this.isActivated = false;
  },
  activated: function () {
    this.isActivated = true;
  },
  methods: {
    saveData: function () {
      if (this.returnTargetList.length !== 0) {
        this.$store.dispatch('form/FORM_NEXTLAYOUT', this.dataTosave);
      }
    },
    alreadyListed: function (index) {
      for (var i = 0; i < this.returnTargetList.length; i++) {
        if (this.targetFitnessVarList[index] === this.returnTargetList[i]) {
          return i;
        }
      }
      return false;
    },
    addElementToList: function (index) {
      var indexAlreadyListed = this.alreadyListed(index);
      if (indexAlreadyListed === false) {
        this.returnTargetList.push(this.targetFitnessVarList[index]);
      } else {
        this.returnTargetList.splice(indexAlreadyListed, 1);
      }
    }
  },
  computed: {
    dataTosave: function () {
      return {
        targetFitness: {
          targetFitnessList: [...this.returnTargetList],
          actualForm: this.actualForm
        }
      };
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/layouts/TargetFitness.vue